import { LastMile } from '../app-bar-menus/assets';
import SolutionsMenuAppBar from '../app-bar-menus';

const solutions = {
    title: "solutionsMenu.title",
    subtitle: "solutionsMenu.subtitle",
    list: [
        {
            title: "solutionsMenu.mapitShip.title",
            description: "solutionsMenu.mapitShip.subtitle",
            image: LastMile,
            href: '/solutions/mapit-ship'
        },
        {
            title: "solutionsMenu.lastMile.title",
            description: "solutionsMenu.lastMile.subtitle",
            image: LastMile,
            href: '/solutions/last-mile'
        },
    ],
    learnMore: "solutionsMenu.learnMore"
}

const SolutionsMenu = () => {

    return (
        <SolutionsMenuAppBar solutions={solutions} />
    );
}

export default SolutionsMenu;
